"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactIntl = require("react-intl");

var _default = (0, _reactIntl.defineMessages)({
  recruit: {
    id: "window.partyFind.tableHeader.recruit",
    defaultMessage: "Recruit",
    description: ""
  },
  waiting: {
    id: "window.partyFind.tableHeader.waiting",
    defaultMessage: "Waiting",
    description: ""
  },
  name: {
    id: "window.partyFind.columnHeader.name",
    defaultMessage: "Name",
    description: ""
  },
  lv: {
    id: "window.partyFind.columnHeader.lv",
    defaultMessage: "Lv",
    description: ""
  },
  avgLv: {
    id: "window.partyFind.columnHeader.avgLv",
    defaultMessage: "Avg. Lv",
    description: ""
  },
  partyLv: {
    id: "window.partyFind.columnHeader.partyLv",
    defaultMessage: "Party Lv",
    description: ""
  },
  class: {
    id: "window.partyFind.columnHeader.class",
    defaultMessage: "Class",
    description: ""
  },
  apply: {
    id: "window.partyFind.button.apply",
    defaultMessage: "Apply",
    description: ""
  },
  whisper: {
    id: "window.partyFind.button.whisper",
    defaultMessage: "Whisper",
    description: ""
  },
  regCancel: {
    id: "window.partyFind.button.regCancel",
    defaultMessage: "Reg./Cancel",
    description: ""
  },
  refresh: {
    id: "window.partyFind.button.refresh",
    defaultMessage: "Refresh",
    description: ""
  },
  reg: {
    id: "window.partyFind.button.reg",
    defaultMessage: "Reg.",
    description: ""
  },
  cancel: {
    id: "window.partyFind.button.cancel",
    defaultMessage: "Cancel",
    description: ""
  },
  invite: {
    id: "window.partyFind.button.invite",
    defaultMessage: "Invite",
    description: ""
  }
});

exports.default = _default;